// Brevo contact list ids
export enum ContactListId {
  SALES = 162,
  MEDIA = 163,
  CAREERS = 164,
  TALENT_CAMP = 199
}
